module.exports = __webpack_public_path__ + "static/media/lists.d5826e9c.png";